import axios from "axios"
import { BACKEND } from "../../config/configEnvs"

export const GetWorkers = async (query = "") => {
  try {
    const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&[activo][equals]=true${query}`)
    return response.data.docs
  } catch (e) {
    return false
  }
}